<p class="vl-card-description">
	<ng-content></ng-content>
</p>
